import { Component, Inject } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CommentEntityTypeEnum } from '../../../dave-data-module/entities/comment.entity';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { CommentIcon } from '../../../helper/page-metadata';

export interface CommentListDialogComponentDialogData {
    entityId: number;
    entityType: CommentEntityTypeEnum;
}
@Component({
    selector: 'app-comment-list-dialog',
    templateUrl: './comment-list-dialog.component.html',
    styleUrls: ['./comment-list-dialog.component.scss'],
})
export class CommentListDialogComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '28rem',
    };
    constructor(@Inject(MAT_DIALOG_DATA) dialogData: CommentListDialogComponentDialogData) {
        this.entityId = dialogData.entityId;
        this.entityType = dialogData.entityType;
    }

    protected readonly CommentEntityTypeEnum = CommentEntityTypeEnum;
    entityId: number;
    entityType: CommentEntityTypeEnum;
    protected readonly CommentIcon = CommentIcon;
}
